var App = App || {};

App.CmpMediaCarousel = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");
        if (!carousel.length)
            return false;

        Carousel(carousel);
    }

    function Carousel(carousel, options) {

        const status = carousel.find(".splide__status");
        const splide = new Splide(carousel[0], {
            type: "loop",
            focus: "center",
            pagination: false,
            autoWidth: true
        });

        // Use delivered image dimensions (naturalWidth/naturalHeight), not CSS sizing,
        // to determine orientation for multi-media slides.
        ApplyOrientationFromRenderedMedia(carousel);

        splide.on('mounted', function () {
            ApplyOrientationFromRenderedMedia(carousel, splide);

            status.children(".current").text("1");
            status.children(".divider").text("/");
            status.children(".total").text(splide.length);

            App.CmpMultiMedia.TranscriptAlignment(carousel);
        });
        
        splide.on('resize', function () {
            App.CmpMultiMedia.TranscriptAlignment(carousel);
        });

        splide.on('move', function (newIndex, prevIndex) {

            status.children(".current").text(newIndex + 1);

            const multiMedia = carousel.find(".cmp--multiMedia__video iframe").parents(".cmp--multiMedia__video");
            multiMedia.each(function () {
                App.CmpMultiMedia.Stop($(this));
            });
        });

        splide.mount({});

    }

    function ApplyOrientationFromRenderedMedia(carousel, splide) {
        carousel.find(".cmp--multiMedia").each(function () {
            const multiMedia = $(this);

            if (multiMedia.find(".cmp--multiMedia__video").length) {
                SetOrientation(multiMedia, "landscape", carousel, splide);
                return;
            }

            const image = multiMedia.find(".cmp--multiMedia__image img").first();
            if (!image.length)
                return;

            const apply = function () {
                const node = image[0];
                const width = node.naturalWidth || node.width;
                const height = node.naturalHeight || node.height;

                if (!width || !height)
                    return;

                const orientation = width > height ? "landscape" : "portrait";
                SetOrientation(multiMedia, orientation, carousel, splide);
            };

            if (image[0].complete) {
                apply();
            }
            else {
                image.one("load.cmpMediaCarouselOrientation", apply);
            }
        });
    }

    function SetOrientation(multiMedia, orientation, carousel, splide) {
        if (multiMedia.attr("data-orientation") === orientation)
            return;

        multiMedia.attr("data-orientation", orientation);

        if (splide) {
            splide.refresh();
            App.CmpMultiMedia.TranscriptAlignment(carousel);
        }
    }

    return {
        Init: Init
    };

})(jQuery);